export { default } from './CorrespondenceSection';
